import React, {Component} from "react";
import "../../style/App.css";
import { connect } from 'react-redux';
import {FaArrowsAltH, FaFileAlt, FaComments, FaExchangeAlt} from "react-icons/fa";
import FullScreenTemplateGeneration from "../../templates/FullScreenTemplateGeneration";
import {SideBarFileUpload} from "./SideBarFileUpload";
import OnlyPDF from "./OnlyPDF";
import {
    addMessageInDocument,
    addToCurrentChatResponse, appendToMessageInDocument,
    resetCurrentChatResponse, setCurrentChatClaudeID, setCurrentChatQuestion,
    setCurrentChatSelectionText,
    setCurrentChatType, setCurrentChatUserID, updateMessageInDocument
} from "../../redux/reducers";
import OnlyPDFImage from "./OnlyPDFImage";
import {SidebarGenerationImage} from "../../components/SidebarComponents/SidebarGenerationImage";
import FullScreenTemplateGenerationImage from "../../templates/FullScreenTemplateGenerationImage";

class PDFPageGenerationImage extends Component {
    constructor(props) {
        super(props);
        this.pdfRef = null;
    }

    state = {
        areaSelectionEnabled: false,
        currentPage: 1,
        totalPages: 14,
        thumbnails: [],
        isRendering: false,
        renderQueue: [],
        zoomLevel: 1,
        isResizing: false,
        panelWidth: this.props.isGeneratePDFVisible ? 50 : 50,
        mobileActivePanel: 'left', // 'left' or 'right'
        url: "",
    };

    handleMouseDown = (e) => {
        this.setState({
            isResizing: true,
            initialPos: e.clientX,
        });
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleMouseUp);
    }

    handleMouseUp = () => {
        this.setState({
            isResizing: false,
        });
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleMouseUp);
    }

    handleMouseMove = (e) => {
        if (this.state.isResizing) {
            const containerRect = this.container.getBoundingClientRect();
            const newPanelWidth = ((e.clientX - containerRect.left) / containerRect.width) * 100;

            // you can also add some conditions to set min and max width limits
            this.setState({ panelWidth: newPanelWidth });
        }
    }

    componentDidMount() {
        this.setState({
            panelWidth: this.props.isGeneratePDFVisible ? 50 : 50,
        });
    }

    toggleMobilePanel = () => {
        this.setState(prevState => ({
            mobileActivePanel: prevState.mobileActivePanel === 'left' ? 'right' : 'left'
        }));
    }

    render() {
        const { mobileActivePanel } = this.state;

        return (
            <FullScreenTemplateGenerationImage generationTitle={this.props.documentGeneration?.name || "Your Images"} generation={this.props.documentGeneration}>
                {/* Mobile Toggle Button */}
                {this.props.isMobile && (
                    <div style={{
                        position: 'fixed',
                        top: mobileActivePanel === 'right' ? '78px' : '118px',
                        bottom: 'auto',
                        right: '15px',
                        zIndex: 1000,
                        backgroundColor: '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50px',
                        padding: '12px 16px',
                        cursor: 'pointer',
                        boxShadow: '0 4px 12px rgba(0, 123, 255, 0.3)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontSize: '14px',
                        fontWeight: '500',
                        transition: 'all 0.3s ease',
                    }}
                         onClick={this.toggleMobilePanel}
                         onMouseEnter={(e) => {
                             e.target.style.backgroundColor = '#0056b3';
                             e.target.style.transform = 'scale(1.05)';
                         }}
                         onMouseLeave={(e) => {
                             e.target.style.backgroundColor = '#007bff';
                             e.target.style.transform = 'scale(1)';
                         }}
                    >
                        <FaExchangeAlt size={16} />
                        {mobileActivePanel === 'left' ? (
                            <>
                                <FaComments size={16} />
                                <span>Chat</span>
                            </>
                        ) : (
                            <>
                                <FaFileAlt size={16} />
                                <span>File</span>
                            </>
                        )}
                    </div>
                )}

                <div className="App" style={{
                    display: "flex",
                    height: '100%',
                    width:'100%',
                    flexDirection: this.props.isMobile ? 'column' : 'row'
                }} ref={ref => this.container = ref}>

                    {/* Left Panel - PDF/File Upload */}
                    {(!this.props.isMobile || mobileActivePanel === 'left') && (
                        <div style={{
                            height: this.props.isMobile ? "100%" : "100%",
                            width: this.props.isMobile ? "100%" : `${this.state.panelWidth}%`,
                            position: "relative",
                            backgroundColor: "white",
                        }}>
                            <OnlyPDFImage
                                generation={this.props.documentGeneration}
                                url={this.state.url}
                                onRef={ref => this.pdfRef = ref}
                            />
                        </div>
                    )}

                    {/* Desktop Divider - Hidden on Mobile */}
                    {!this.props.isMobile && (
                        <div
                            onMouseDown={this.handleMouseDown}
                            style={{
                                cursor: 'ew-resize',
                                width: '0.3rem',
                                backgroundColor: 'grey',
                                height: 'calc(100% + 3rem)',
                                position: 'relative',
                            }}
                        >
                            <span
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    fontSize: '12px',
                                    color: 'white',
                                    userSelect: 'none',
                                }}
                            >
                                <FaArrowsAltH size={'1rem'} color={'black'}/>
                            </span>
                        </div>
                    )}

                    {/* Right Panel - Chat Sidebar */}
                    {this.props.isChatVisible && (!this.props.isMobile || mobileActivePanel === 'right') && (
                        <SidebarGenerationImage
                            documentGeneration={this.props.documentGeneration}
                            sessionTokenGeneration={this.props.sessionTokenGeneration}
                            width={this.props.isMobile ? 100 : 100 - this.state.panelWidth}
                            socketIDGeneration={this.props.socketIDGeneration}
                            socketGeneration={this.props.socketGeneration}
                            pdfRef={this.pdfRef}
                        />
                    )}
                </div>
            </FullScreenTemplateGenerationImage>
        )
    }
}

const mapStateToProps = state => ({
    isChatVisible: state.settings.isChatVisible,
    isGeneratePDFVisible: state.settings.isGeneratePDFVisible,
    currentChatUserIDGeneration: state.settings.currentChatUserIDGeneration,
    currentChatClaudeIDGeneration: state.settings.currentChatClaudeIDGeneration,
    currentChatSelectionTextGeneration: state.settings.currentChatSelectionTextGeneration,
    currentChatQuestionGeneration: state.settings.currentChatQuestionGeneration,
    currentChatTypeGeneration: state.settings.currentChatTypeGeneration,
    currentChatResponseGeneration: state.settings.currentChatResponseGeneration,
});

const mapDispatchToProps = {
    addMessageInDocument,
    appendToMessageInDocument,
    updateMessageInDocument,
    setCurrentChatQuestion,
    setCurrentChatUserID,
    setCurrentChatClaudeID,
    setCurrentChatSelectionText,
    setCurrentChatType,
    addToCurrentChatResponse,
    resetCurrentChatResponse,
};

export default connect(mapStateToProps, mapDispatchToProps)(PDFPageGenerationImage);
